import React from "react";
import PropTypes from "prop-types";
import Select from "wonderbly-components/lib/Select";

const ShippingCountry = (props) => (
  <div className="shipping-country">
    {!props.isTwoColumnLayout && <h3>{props.header}</h3>}
    <Select
      onChange={props.onChange}
      value={props.countryIso}
      options={props.countries}
      className="shipping-country-list"
      id="shipping-countries"
      name="countryIso"
    />
    {props.states.length > 0 && (
      <Select
        onChange={props.onChange}
        value={props.stateAbbr}
        options={props.states}
        className="shipping-state-list"
        id="shipping-states"
        name="stateAbbr"
      />
    )}
  </div>
);

ShippingCountry.propTypes = {
  header: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  countryIso: PropTypes.string.isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  stateAbbr: PropTypes.string,
  states: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  isTwoColumnLayout: PropTypes.bool,
};

export default ShippingCountry;
